module.exports = __webpack_public_path__ + "media/landing_page/twitter-cashew-4e541195.svg";